import { render, staticRenderFns } from "./basic_list.vue?vue&type=template&id=225b4306&scoped=true"
import script from "./basic_list.vue?vue&type=script&lang=js"
export * from "./basic_list.vue?vue&type=script&lang=js"
import style0 from "./basic_list.vue?vue&type=style&index=0&id=225b4306&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b4306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225b4306')) {
      api.createRecord('225b4306', component.options)
    } else {
      api.reload('225b4306', component.options)
    }
    module.hot.accept("./basic_list.vue?vue&type=template&id=225b4306&scoped=true", function () {
      api.rerender('225b4306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/monthly_attendance/components/basic_list.vue"
export default component.exports